import { render, staticRenderFns } from "./Pyms.vue?vue&type=template&id=f59e468c&"
import script from "./Pyms.vue?vue&type=script&lang=js&"
export * from "./Pyms.vue?vue&type=script&lang=js&"
import style0 from "./Pyms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports